var render, staticRenderFns
import script from "./ib-table-edit.vue?vue&type=script&lang=js&"
export * from "./ib-table-edit.vue?vue&type=script&lang=js&"
import style0 from "./ib-table-edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-table-edit.vue?vue&type=custom&index=0&blockType=ib-example&name=Movable%2FRemovable%20Widgets"
if (typeof block0 === 'function') block0(component)
import block1 from "./ib-table-edit.vue?vue&type=custom&index=1&blockType=ib-example&name=Data%20as%20Object%2C%20No%20Delete%20Confirmation"
if (typeof block1 === 'function') block1(component)

/* hot reload */
if (module.hot) {
  var api = require("c:\\dev\\projects\\web.app\\lib.common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb3d97c')) {
      api.createRecord('2fb3d97c', component.options)
    } else {
      api.reload('2fb3d97c', component.options)
    }
    
  }
}
component.options.__file = "src/components/table/ib-table-edit.vue"
export default component.exports